<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { Head } from '@inertiajs/inertia-vue3'
import { onMounted, onUnmounted } from 'vue'
import ButtonRounded from '@/Shared/Buttons/ButtonRounded'
import TextFor from '@/Shared/Icons/TextFor'
import usePref from '@/Shared/usePref.js'

const props = defineProps({
  myvalue: Array,
  pref: Object,
})

onMounted(() => {
  usePref(props.pref)
})

onUnmounted(() => {})
</script>

<template>
  <div class="contact">
    <Head title="お問い合わせ" />

    <div class="bg-afgray md:min-h-[calc(100vh_-_75px)] xl:min-h-screen md:grid md:items-center">
      <div class="m-auto px-[calc(5vw_+_10px)] xs:px-[40px] sm:px-[80px] md:px-0 pb-[60px] sm:pb-[80px] md:pb-0 md:w-[600px]">
        <div class="mb-[40px] md:mb-[50px]">
          <h2 class="page-title !text-left !pt-[0.8em] sm:!pt-[1em] md:!pt-0 !pb-[0.4em]">
            <TextFor />
            DEALERS
            <small>商品の卸先様へ</small>
          </h2>

          <div class="mx-auto text-[110%] text-left leading-[2] [&>p]:mb-[10px]">
            <p>商品の卸先様からのお問い合わせはこちらで承っております。<br class="hidden md:block" />弊社ブランドの取り扱いについてなどお気軽にお問い合わせください。</p>
          </div>
        </div>

        <ul class="mx-auto [&>li]:mb-[20px] [&>li]:md:w-full [&_a]:md:h-[70px] [&_a]:font-medium md:flex md:gap-[20px]">
          <li>
            <ButtonRounded text="新規の卸先様へ" url="/inquiry/start" icon="arrow" class="drop-shadow-[0_0_50px_rgba(0,0,0,0.05)]" style="background-color: #fff" />
          </li>
          <li>
            <ButtonRounded text="お取引中の卸先様へ" url="/inquiry/support" icon="arrow" class="drop-shadow-[0_0_50px_rgba(0,0,0,0.05)]" style="background-color: #fff" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
